export default __webpack_public_path__ + "static/media/ABOUT_US.ecf19dfd.jpg";